import { cn } from "@/lib/utils"
import { LucideIcon } from "lucide-react"

interface DeliveryOptionProps {
  id: string
  title: string
  description: string
  price: number
  icon: LucideIcon
  selected: boolean
  onSelect: (id: string) => void
}

export function DeliveryOption({
  id,
  title,
  description,
  price,
  icon: Icon,
  selected,
  onSelect
}: DeliveryOptionProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-between p-4 rounded-lg cursor-pointer transition-colors",
        selected
          ? "bg-purple-50 border-2 border-purple-500"
          : "border border-gray-200 hover:border-purple-300"
      )}
      onClick={() => onSelect(id)}
    >
      <div className="flex items-center gap-4">
        <div className={cn(
          "p-2 rounded-lg",
          selected ? "bg-purple-100" : "bg-gray-100"
        )}>
          <Icon className={cn(
            "w-6 h-6",
            selected ? "text-purple-500" : "text-gray-500"
          )} />
        </div>
        <div>
          <h3 className="font-semibold">{title}</h3>
          <p className="text-sm text-gray-500">{description}</p>
        </div>
      </div>
      <div className="font-semibold">${price.toFixed(2)}</div>
    </div>
  )
}